import  React, {use, useEffect, useState} from 'react';
import "./styles/Tabla_relacion.css";
import { useNavigate } from "react-router-dom";
import { FaPencilAlt } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa";
import { FaSync } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import axios from 'axios';
import { CgWebcam } from 'react-icons/cg';
import { eventWrapper } from '@testing-library/user-event/dist/utils';
import Cookies from 'js-cookie';
import { FaChartPie } from "react-icons/fa";
import MensajeAlerta from './MensajeAlerta';
import MensajeError from './MensajeError';
import { useConfig } from '../contexts/ConfigContext';
import { GoGraph } from "react-icons/go";
import { FaFileUpload } from "react-icons/fa";

//RpPr
const Tabla_relacion = () =>{

    const config = useConfig();
    const API_URL = `${config.API_URL}/api/registro/`;

    const [loadingiIco, setLoadingIco] = useState(false);
    const navigate = useNavigate();

    const [reiniciarPagina, setReiniciarPagina] = useState(false);
    const [paginaActual, setPaginaActual] = useState(0);
    const [paginaTamano, setPaginaTamano] = useState(0);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [items, setItems] = useState([]);
    const [anosList, setAnosList] = useState([]);
    const [totalRegCargados, setTotalRegCargados] = useState(0);

    //Busqueda 
    const [añoBusqueda, setAñoBusqueda] = useState('');
    const [columnaBusqueda, setColumnaBusqueda] = useState('0');
    const [valorBusqueda, setValorBusqueda] = useState('');

    const [genericMensajeError, setGenericMensajeError] = useState('');
    const [showMensajeError, setShowMensajeError] = useState(false);
    const [genericMensajeAlert, setGenericMensajeAlert] = useState('');
    const [showMensajeAlert, setShowMensajeAlert] = useState(false);

    //ACERCA 
    const [nombreHoja, setNombreHoja] = useState('');
    

    const [admin, setAdmin] = useState(false);
    const validarSesion = () =>{
            if(Cookies.get("turid")){
                const turid = Cookies.get("turid");
                if(turid === "rid1"){
                    setAdmin(true);
                }else if(turid === "rid2"){
                    setAdmin(false);
                }else{
                    navigate("/");
                    Cookies.remove("usr");
                    Cookies.remove("turid");
                }
            }else{
                navigate("/");
                Cookies.remove("usr");
            }

    }

    useEffect(() =>{
        validarSesion();
    const JSONPagina = {
        "paginaActual": 0,
        "paginaTamano": 0,
        "totalRegistros": 0,
        "totalPaginas": 0,
        "registroList": []
    }

    //Configuramos axios para que añada al header el respectivo token
    axios.interceptors.request.use(
    (config) => {
        const token = Cookies.get('usr');
        if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.error(error)
    }
    );
    

    const inicializarRegistros = async ()=>{
        try{
            const response = await axios.post(API_URL + "cargar_registros", JSONPagina, {Authorization: true});
            const JSONResumen = response.data;
            setPaginaActual(JSONResumen["paginaActual"]);
            setPaginaTamano(JSONResumen["paginaTamano"]);
            setTotalRegistros(JSONResumen["totalRegistros"]);
            setTotalPaginas(JSONResumen["totalPaginas"]);
            setItems(JSONResumen.registroList);
            setAnosList(JSONResumen.lista_anos);

            const regCargados = JSONResumen["paginaTamano"] * JSONResumen["paginaActual"];
            
            if(JSONResumen["totalRegistros"] === 0){
                    setTotalRegCargados(0);
            }else{
                 if(regCargados < JSONResumen["totalRegistros"]){
                    setTotalRegCargados(regCargados);
                }else{
                    setTotalRegCargados(JSONResumen["totalRegistros"]);
                }

            }
           

            
            console.log(response.data);
        }catch(error){
            //alert("Ha ocurrido un error al cargar los tickets" + error);
            console.log(error)
            setGenericMensajeError("Ha ocurrido un error al cargar los registros: "+error);
            setShowMensajeError(true);
        }
    };
    
    inicializarRegistros();        
    },[]);




    const handleEditar = (idRegistro) =>{
     
        navigate(`/editar?id_registro=${idRegistro}`);
    }

    const handleMostrarFormularioSubirReporte = () =>{
        navigate(`/RelacionSubirReporte`);
    }
    const handleMostrarEstadisticas = () =>{
        navigate('/estadisticas')
    }

    const handleAñoChallenge = (event) =>{
        setAñoBusqueda(event.target.value);
        setReiniciarPagina(true);
    }

    const handleColumnaChallenge = (event) =>{
        setColumnaBusqueda(event.target.value);
        setReiniciarPagina(true);
    }

    const handleBusquedaChallenge = (event) =>{
        setValorBusqueda(event.target.value);
        setReiniciarPagina(true);
    }

    const handleCargar = async(e)=>{
        e.preventDefault();
        if(paginaActual === totalPaginas){
            return null;
        }

        
        
         //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );

        var nuevaPagina = paginaActual + 1;
        if(columnaBusqueda === '0') setColumnaBusqueda('17');
        //if(valorBusqueda === '') setColumnaBusqueda('0');

        const JSONPagina = {
            "year": añoBusqueda,
            "columna": columnaBusqueda,
            "valor": valorBusqueda,
            "pagina_registros": {
                "paginaActual": nuevaPagina,
                "paginaTamano": 0,
                "totalRegistros": 0,
                "totalPaginas": 0,
                "registroList": []
            }
            }
            console.log(JSONPagina);
        try{
            const response = await axios.post(API_URL + "buscar_registros", JSONPagina, {Authorization: true});
            const JSONResumen = response.data;
            setPaginaActual(JSONResumen["paginaActual"]);
            setPaginaTamano(JSONResumen["paginaTamano"]);
            setTotalRegistros(JSONResumen["totalRegistros"]);
            setTotalPaginas(JSONResumen["totalPaginas"]);
            setItems([...items, ...JSONResumen.registroList]);
            console.log(JSONResumen.registroList);


            const regCargados = JSONResumen["paginaTamano"] * JSONResumen["paginaActual"];

            if(JSONResumen["totalRegistros"] === 0){
                    setTotalRegCargados(0);
            }else{
                 if(regCargados < JSONResumen["totalRegistros"]){
                    setTotalRegCargados(regCargados);
                }else{
                    setTotalRegCargados(JSONResumen["totalRegistros"]);
                }

            }
        }catch(error){
            
            console.log(error)
            setGenericMensajeError("Ha ocurrido un error al realizar la busqueda los registros: "+error);
            setShowMensajeError(true);
        }


        
    }

    

    const handleBuscar = async(e) =>{
        e.preventDefault();
        var pgActual;

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );


        
        if(reiniciarPagina) pgActual = 0; else pgActual = paginaActual;

        if(columnaBusqueda === '0') setColumnaBusqueda('17');
        //if(valorBusqueda === '') { setColumnaBusqueda('0');}

        const JSONPagina = {
            "year": añoBusqueda,
            "columna": columnaBusqueda,
            "valor": valorBusqueda,
            "pagina_registros": {
                "paginaActual": pgActual,
                "paginaTamano": 0,
                "totalRegistros": 0,
                "totalPaginas": 0,
                "registroList": []
            }
            }
            console.log(JSONPagina);
        try{
            const response = await axios.post(API_URL + "buscar_registros", JSONPagina, {Authorization: true});
            const JSONResumen = response.data;
            setPaginaActual(JSONResumen["paginaActual"]);
            setPaginaTamano(JSONResumen["paginaTamano"]);
            setTotalRegistros(JSONResumen["totalRegistros"]);
            setTotalPaginas(JSONResumen["totalPaginas"]);
            setItems(JSONResumen.registroList);
            console.log(JSONResumen.registroList);

            

            const regCargados = JSONResumen["paginaTamano"] * JSONResumen["paginaActual"];
            if(JSONResumen["totalRegistros"] === 0){
                    setTotalRegCargados(0);
            }else{
                 if(regCargados < JSONResumen["totalRegistros"]){
                    setTotalRegCargados(regCargados);
                }else{
                    setTotalRegCargados(JSONResumen["totalRegistros"]);
                }

            }
        }catch(error){
            
            console.log(error)
            setGenericMensajeError("Ha ocurrido un error al realizar la busqueda los registros: "+error);
            setShowMensajeError(true);
        }
    }

    const formatearFecha = (fechaDateTime) =>{

        const fecha = fechaDateTime.substring(0, 10);
        const componentes = fecha.split('-');
        componentes.reverse();
        return componentes.join('-');
    }


    const handleGenerarExcel = async(e) =>{
        e.preventDefault();

        //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );


        if(valorBusqueda === '') setColumnaBusqueda('0');

        const JSONPagina = {
            "year": añoBusqueda,
            "columna": columnaBusqueda,
            "valor": valorBusqueda,
            "pagina_registros": {
                "paginaActual": 1,
                "paginaTamano": 0,
                "totalRegistros": 0,
                "totalPaginas": 0,
                "registroList": []
            }
            }
            console.log(JSONPagina);
        try{
            const response = await axios.post(API_URL + "generar_excel", JSONPagina, {responseType: 'blob'}, {Authorization: true});
            const JSONResumen = response.data;


            const contentDisposition = response.headers['content-disposition'];
            let filename = 'Registros.xlsx'; // Nombre de archivo por defecto

            if (contentDisposition) {
                // Ejemplo: Content-Disposition: attachment; filename="NombreConEspacios.xlsx"
                /*const filenameMatch = contentDisposition.match(/filename\*?=['"]?([^"']*)['"]?/);
                
                if (filenameMatch && filenameMatch[1]) {
                    try {
                        // Decodificar el nombre para manejar caracteres especiales o espacios
                        filename = decodeURIComponent(filenameMatch[1].replace(/\"/g, ''));
                    } catch (decodeError) {
                        console.warn('No se pudo decodificar el nombre de archivo del Content-Disposition, usando el predeterminado.', decodeError);
                    }
                     }*/
                    
                const filenameMatch = contentDisposition.match(/filename="(.+)"|filename=(?!UTF-8)([^;]+)/i);
                    
                if (filenameMatch) {
                    // Tomamos el grupo que no sea null (el 1 o el 2)
                    filename = filenameMatch[1] || filenameMatch[2];
                    
                    // Limpieza final de posibles puntos y comas o espacios sobrantes
                    filename = filename.trim().replace(/;$/g, '');
                }

            }

            // 2. Crear un objeto URL para el Blob (los datos binarios del archivo)
            // response.data ya es el Blob gracias a responseType: 'blob'
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // 3. Crear un enlace (<a>) en el DOM para simular la descarga
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); // Asigna el nombre al archivo descargado

            // 4. Añadir el enlace al DOM, simular un clic y luego limpiarlo
            document.body.appendChild(link);
            link.click(); // Esto dispara la descarga en el navegador
            document.body.removeChild(link);

            // 5. Revocar el objeto URL para liberar la memoria
            window.URL.revokeObjectURL(url);

            console.log('Archivo Excel generado y descargado con éxito!');

            // Si tu API aún devuelve algún JSON, puedes manejarlo aquí
            // const JSONResumen = response.data; // ¡OJO! response.data aquí es el Blob, no el JSON
            // Si necesitas un JSON de la API, la API debe enviarlo por separado o en otro endpoint.

            // Reiniciar mensajes de error si estaban activos
            if (showMensajeError) {
                setShowMensajeError(false);
                setGenericMensajeError("");
            }
            
        }catch(error){
            
            console.log(error)
            setGenericMensajeError("Ha ocurrido un error al realizar la busqueda los registros: "+error);
            setShowMensajeError(true);
        }
    }


    
    const handleCloseError = () => {
        setShowMensajeError(false); // Oculta el mensaje de error cuando el usuario hace clic en "Aceptar"
        setGenericMensajeError(''); // Opcional: limpia el mensaje de error
    };



    return(

        <div className="mainDivTable">
            <MensajeError mensaje={genericMensajeError} show={showMensajeError} onClose={handleCloseError}/>
            <div className='filtrosRegistroTablas'>
                <form className='formularioBusquedaTabla'>
                    <div className='busq1'>
                        <label htmlFor='year' id='tabla_relacion_label_busqueda'>Año: </label>
                        <select className='inputF' id="year" name="year" value={añoBusqueda} onChange={handleAñoChallenge}>
                            <option value="0" selected>Todos</option>
                            {anosList.map((ano, index) =>(
                                <option value={ano}>{ano}</option>
                            ))}
                        </select>
                    </div>
                    <div className='busq2'>
                        <label htmlFor='buscar' id='tabla_relacion_label_busqueda'>Buscar:</label>
                        <input className='inputF' type='text' name='buscar' id='buscar' value={valorBusqueda} onChange={handleBusquedaChallenge}/>
                        <label htmlFor='columna' id='tabla_relacion_label_busqueda'>Buscar por:</label>
                        <select className='inputF' id="columna" name="columna" value={columnaBusqueda} onChange={handleColumnaChallenge}>
                            <option value="0">--Seleccione una columna--</option> 
                            <option value="17">Todos los campos</option>
                            <option value="16">ID</option>
                            <option value="1">Relacion</option>
                            <option value="2">Registro</option>
                            <option value="3">Boleta</option>
                            <option value="4">Nombre</option>
                            <option value="5">Numero de expediente</option>
                            <option value="6">Carrera</option>
                            <option value="7">Prestatario</option>
                            <option value="8">&Aacute;rea</option>
                            <option value="9">Profesor</option>
                            <option value="10">Fecha de inicio</option>
                            <option value="11">Fecha de finalizacion</option>
                            <option value="12">Tipo</option>
                            <option value="13">Creditos</option>
                            <option value="14">Horario</option>
                            <option value="15">OBS</option>
                            
                        </select>
                    </div>
                    <div className='busq3'>
                        
                        <button className='buttonStandart' onClick={handleBuscar} ><FaSearch/>    buscar</button>
                        <button className='buttonStandart' onClick={handleGenerarExcel}><PiMicrosoftExcelLogoFill />Generar reporte</button>
                        {admin && <button className='buttonStandart' onClick={(e) => {e.preventDefault(); handleMostrarFormularioSubirReporte();}}><FaFileUpload/>     Subir reporte</button>}
                        <button className='buttonStandart' onClick={(e) => {e.preventDefault(); handleMostrarEstadisticas();}}><FaChartPie />Estadisticas</button>
                        
                    </div>
                 
                </form>
                 
            </div>
            <div><p>{totalRegCargados} Registros mostrados de {totalRegistros}</p></div>
            <table className="tablaRelacionMain">
                
                <thead className="encabezadosRelacion">
                    <tr>
                        <th>Año</th>
                        <th>Relaci&oacute;n</th>
                        <th>Registro</th>
                        <th>Boleta</th>
                        <th>Nombre</th>
                        <th>Numero de expediente</th>
                        <th>Carrera</th>
                        <th>Prestatario</th>
                        <th>&Aacute;rea</th>
                        <th>Profesor</th>
                        <th>Fecha de inicio</th>
                        <th>Fecha de finalizaci&oacute;n</th>
                        <th>Tipo</th>
                        <th>Creditos</th>
                        <th>Horario</th>
                        <th>OBS</th>
                        <th>Carta compromiso</th>
                        <th>Fecha de recibido de la carta de compromiso</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                    items.map((item)=>(
                        <tr key={item.id_registro} className="registroRelacion">
                            <td>{item.ano}</td>
                            <td>{item.relacion}</td>
                            <td>{item.registro}</td>
                            <td>{item.boleta}</td>
                            <td>{item.nombre}</td>
                            <td>{item.numero_expediente}</td>
                            <td>{item.carrera}</td>
                            <td>{item.prestatario}</td>
                            <td>{item.area}</td>
                            <td>{item.profesor}</td>
                            <td>{item.periodo_fecha_inicio ? formatearFecha(item.periodo_fecha_inicio) : ''}</td>
                            <td>{item.periodo_fecha_fin ? formatearFecha(item.periodo_fecha_fin) : ''}</td>
                            <td>{item.tipo}</td>
                            <td>{item.creditos}</td>
                            <td>{item.horario}</td>
                            <td>{item.obs}</td>
                            <td>{item.carta_compromiso ? item.nombre_recibido_carta :''}</td>
                            <td>{item.fecha_carta_compromiso ? formatearFecha(item.periodo_fecha_fin) : ''}</td>
                            <td>{admin && <button onClick={() => handleEditar(item.id_registro)}><FaPencilAlt color="white"/></button>}</td>
                        </tr>
                    
                    ))}

                </tbody>
            </table>
            <div className="loadMoreBoxTablaRelacion">
                {!loadingiIco && paginaActual !== totalPaginas &&<button onClick={handleCargar}><FaAngleDown color="white"/></button>}
                {loadingiIco && <div className="loading_ico_tabla"><FaSync color=" rgb(51, 51, 51)"/></div>}
                
            </div>
        </div>
    );
}

export default Tabla_relacion;